import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { FC, MouseEventHandler } from 'react';
import { RequestStatusEnum } from './types';
import { WbBadge } from '../WbBadge';

export interface RequestStatusButtonProps {
  status?: RequestStatusEnum;
  handleClick?: MouseEventHandler<HTMLAnchorElement> &
    MouseEventHandler<HTMLSpanElement>;
  label?: string;
}

export const RequestStatusButton: FC<RequestStatusButtonProps> = ({
  status,
  handleClick,
  label,
}) => {
  switch (status) {
    case RequestStatusEnum.PENDING:
    case RequestStatusEnum.WAITING:
      return (
        <WbBadge
          startIcon={<ErrorOutlineIcon fontSize="small" />}
          color="warning"
          onClick={handleClick}
        >
          {status}
        </WbBadge>
      );

    case RequestStatusEnum.GRANT:
      return (
        <WbBadge
          startIcon={<CheckCircleOutlineIcon fontSize="small" />}
          color="success"
          onClick={handleClick}
        >
          {status}
        </WbBadge>
      );
    case RequestStatusEnum.REVOKE:
      return (
        <WbBadge
          startIcon={<ErrorOutlineIcon fontSize="small" />}
          color="error"
          onClick={handleClick}
        >
          {status}
        </WbBadge>
      );

    case RequestStatusEnum.OTHER:
      return (
        <WbBadge
          startIcon={<AssignmentIcon fontSize="small" />}
          color="primary"
          onClick={handleClick}
        >
          {label}
        </WbBadge>
      );

    default:
      return <></>;
  }
};
